/* VITALUX · ficha de producto (pl-*) */
(function () {
  'use strict';

  // Carrusel con puntos, flechas y miniaturas (galería de producto y fila de fotos/vídeos)
  function initSlider(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var track = root.querySelector('[data-pl-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pl-dots] button'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pl-thumbs] button'));
    var current = 0;

    function perView() {
      var w = slides[0] ? slides[0].getBoundingClientRect().width : 1;
      return Math.max(1, Math.round(track.clientWidth / w));
    }
    function setActive(i) {
      current = i;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      var t = thumbs[i];
      if (t && t.parentNode.scrollTo) t.parentNode.scrollTo({ left: t.offsetLeft - t.parentNode.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
    }
    function go(i) {
      var last = Math.max(0, slides.length - perView());
      if (i < 0) i = last;
      if (i > last) i = 0;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    root.plGo = go;
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var prev = root.querySelector('[data-pl-prev]');
    var next = root.querySelector('[data-pl-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var w = slides[0] ? slides[0].getBoundingClientRect().width : 1;
        var gap = slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft - w : 0;
        var i = Math.round(track.scrollLeft / (w + gap));
        if (i !== current && i >= 0 && i < slides.length) setActive(i);
      });
    }, { passive: true });
  }

  function money(cents) {
    var fmt = window.plMoneyFormat || '{{amount_with_comma_separator}} €';
    var v = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, v);
  }

  function initProduct(wrap) {
    if (wrap.dataset.ready) return;
    wrap.dataset.ready = '1';
    var dataEl = wrap.querySelector('[data-pl-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = wrap.querySelector('form[data-pl-form]');
    var idInput = form.querySelector('input[name="id"]');
    var btn = form.querySelector('.pl-atc');
    var err = form.querySelector('.pl-error');
    var gal = wrap.querySelector('[data-pl-gallery]');
    var fieldsets = wrap.querySelectorAll('[data-pl-option]');

    function update() {
      var sel = Array.prototype.map.call(fieldsets, function (fs) {
        var c = fs.querySelector('input:checked');
        fs.querySelector('[data-pl-chosen]').textContent = c ? c.value : '';
        return c ? c.value : null;
      });
      updateBundles(sel);
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
      if (!v) { btn.disabled = true; btn.textContent = btn.dataset.unavailable; return; }
      idInput.value = v.id;
      currentPrice = v.price;
      updateQty();
      wrap.querySelectorAll('[data-pl-terms] input[name="id"]').forEach(function (el) {
        el.value = v.id;
        el.dispatchEvent(new Event('change', { bubbles: true }));
      });
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.dataset.add : btn.dataset.soldout;
      wrap.querySelectorAll('[data-pl-price]').forEach(function (el) { el.textContent = money(v.price); });
      wrap.querySelectorAll('[data-pl-save]').forEach(function (el) {
        var off = v.compare_at_price > v.price;
        el.hidden = !off;
        if (off) el.textContent = (el.dataset.label || 'Ahorra [ahorro]').replace('[ahorro]', money(v.compare_at_price - v.price));
      });
      wrap.querySelectorAll('[data-pl-compare]').forEach(function (el) {
        el.hidden = !(v.compare_at_price > v.price);
        el.textContent = v.compare_at_price ? money(v.compare_at_price) : '';
      });
      if (v.featured_media && gal && gal.plGo) {
        var slide = gal.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (slide) gal.plGo(Array.prototype.indexOf.call(slide.parentNode.children, slide));
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    // Colgantes: muestra una subida de foto por colgante elegido
    var bundleFs = wrap.querySelector('[data-pl-bundle]');
    var bundleIdx = Array.prototype.indexOf.call(fieldsets, bundleFs);
    var ups = Array.prototype.slice.call(wrap.querySelectorAll('[data-pl-upload]'));
    // Packs de unidades: cantidad del carrito, precio total de cada tarjeta y nº de fotos
    var qtyFs = wrap.querySelector('[data-pl-qty]');
    var qtyInput = qtyFs ? qtyFs.querySelector('[data-pl-qty-input]') : null;
    var currentPrice = null;
    function qtyValue() {
      var c = qtyFs ? qtyFs.querySelector('input[name="pl-qb"]:checked') : null;
      return c ? parseInt(c.value, 10) || 1 : 1;
    }
    // Cuota de Klarna: precio final del pack elegido ÷ número de plazos
    function updateKlarna() {
      var k = wrap.querySelector('[data-pl-klarna]');
      if (!k || currentPrice == null) return;
      var c = qtyFs ? qtyFs.querySelector('input[name="pl-qb"]:checked') : null;
      var n = qtyValue(), off = c ? parseInt(c.dataset.off, 10) || 0 : 0, fixed = c ? parseInt(c.dataset.fixed, 10) || 0 : 0;
      var total = currentPrice * n;
      var final = fixed > 0 ? fixed : total - Math.floor(total * off / 100);
      k.querySelector('[data-pl-klarna-cuota]').textContent = money(Math.round(final / (parseInt(k.dataset.n, 10) || 3)));
    }
    function updateQty() {
      updateKlarna();
      if (!qtyFs) return;
      var n = qtyValue();
      qtyInput.value = n;
      qtyFs.querySelector('[data-pl-qty-chosen]').textContent = n;
      if (currentPrice != null) {
        qtyFs.querySelectorAll('input[name="pl-qb"]').forEach(function (r) {
          var k = parseInt(r.value, 10), off = parseInt(r.dataset.off, 10) || 0, fixed = parseInt(r.dataset.fixed, 10) || 0;
          var total = currentPrice * k;
          var final = fixed > 0 ? fixed : total - Math.floor(total * off / 100);
          var card = r.nextElementSibling, was = card.querySelector('[data-pl-qb-was]');
          card.querySelector('[data-pl-qb-price]').textContent = money(final);
          if (was) { was.hidden = !(final < total); was.textContent = money(total); }
        });
      }
    }
    if (qtyFs) qtyFs.addEventListener('change', function () { updateQty(); updateBundles(lastSel); });
    var lastSel = [];
    // Recuadros por collar: cada unidad elige su color, foto y nombre
    var unitsWrap = wrap.querySelector('[data-pl-units]');
    var units = unitsWrap ? Array.prototype.slice.call(unitsWrap.querySelectorAll('[data-pl-unit]')) : [];
    var swIdx = unitsWrap ? parseInt(unitsWrap.dataset.swIdx, 10) : -1;
    function variantFor(color) {
      var sel = lastSel.slice();
      if (swIdx >= 0 && color != null) sel[swIdx] = color;
      return variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
    }
    function unitColor(u) {
      var c = u.querySelector('[data-pl-unit-color]:checked');
      return c ? c.value : null;
    }
    units.forEach(function (u, k) {
      u.addEventListener('change', function (e) {
        if (!e.target.matches('[data-pl-unit-color]')) return;
        u.querySelector('[data-pl-unit-chosen]').textContent = e.target.value;
        if (k === 0 && swIdx >= 0) {
          // la unidad 1 manda en el precio y la galería
          var g = fieldsets[swIdx].querySelector('input[value="' + e.target.value.replace(/"/g, '\\"') + '"]');
          if (g) { g.checked = true; update(); }
        } else {
          var v = variantFor(e.target.value);
          if (v && v.featured_media && gal && gal.plGo) {
            var slide = gal.querySelector('[data-media-id="' + v.featured_media.id + '"]');
            if (slide) gal.plGo(Array.prototype.indexOf.call(slide.parentNode.children, slide));
          }
        }
      });
    });
    function updateBundles(sel) {
      lastSel = sel;
      var count = Math.max(bundleFs ? parseInt(sel[bundleIdx], 10) || 1 : 1, qtyValue());
      units.forEach(function (u) { u.hidden = parseInt(u.dataset.plUnit, 10) > qtyValue(); });
      ups.forEach(function (u) {
        var on = parseInt(u.dataset.n, 10) <= count;
        u.hidden = !on;
        u.querySelector('input[type=file]').disabled = !on;
      });
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
    if (bundleFs || qtyFs) update();

    // Subir foto: muestra la miniatura y el nombre del archivo
    ups.concat(Array.prototype.slice.call(wrap.querySelectorAll('[data-pl-uup]'))).forEach(function (up) {
      var file = up.querySelector('input[type=file]');
      var label = up.querySelector('.pl-up__btn');
      var original = label.innerHTML;
      file.addEventListener('change', function () {
        up.classList.remove('is-error');
        var f = file.files && file.files[0];
        if (!f) { up.classList.remove('is-done'); label.innerHTML = original; return; }
        var max = (parseInt(up.dataset.maxMb, 10) || 20) * 1024 * 1024;
        if (f.size > max) {
          file.value = '';
          up.classList.remove('is-done');
          up.classList.add('is-error');
          label.innerHTML = original;
          err.textContent = up.dataset.tooBig;
          return;
        }
        err.textContent = '';
        up.classList.add('is-done');
        var name = f.name.length > 26 ? f.name.slice(0, 23) + '…' : f.name;
        label.textContent = '';
        if (/^image\//.test(f.type) && window.URL) {
          var img = document.createElement('img');
          img.src = URL.createObjectURL(f);
          img.alt = '';
          label.appendChild(img);
        }
        label.appendChild(document.createTextNode('✓ ' + name + ' · ' + up.dataset.change));
      });
    });

    form.dataset.plReady = '1';
    form.addEventListener('submit', function (e) {
      err.textContent = '';
      var missing = ups.filter(function (u) {
        var f = u.querySelector('input[type=file]');
        return !u.hidden && f.required && !(f.files && f.files.length);
      })[0];
      if (missing) {
        e.preventDefault();
        missing.classList.add('is-error');
        err.textContent = missing.dataset.required;
        missing.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (units.length) { e.preventDefault(); addUnits(); return; }
      var drawer = document.querySelector('cart-drawer');
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      btn.classList.add('is-loading');
      var fd = new FormData(form);
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        fd.append('sections_url', window.location.pathname);
      }
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { err.textContent = res.description || res.message || 'No se pudo añadir.'; return; }
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () { form.submit(); })
        .finally(function () { btn.classList.remove('is-loading'); });
    });

    function addUnits() {
      var n = qtyValue();
      var list = units.slice(0, n);
      var missing = list.filter(function (u) {
        var f = u.querySelector('input[type=file]');
        return f && f.dataset.must === 'true' && !(f.files && f.files.length);
      })[0];
      if (missing) {
        var up = missing.querySelector('[data-pl-uup]');
        up.classList.add('is-error');
        err.textContent = up.dataset.required;
        missing.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var drawer = document.querySelector('cart-drawer');
      var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
      var d = unitsWrap.dataset;
      btn.classList.add('is-loading');
      btn.disabled = true;
      var chain = Promise.resolve();
      var last = null;
      list.forEach(function (u, k) {
        chain = chain.then(function () {
          var v = variantFor(unitColor(u));
          if (!v || !v.available) throw new Error('Ese color no está disponible.');
          var fd = new FormData();
          fd.append('id', v.id);
          fd.append('quantity', '1');
          var f = u.querySelector('input[type=file]');
          if (f && f.files && f.files[0]) fd.append('properties[' + d.propPhoto + ']', f.files[0]);
          var nm = u.querySelector('[data-pl-unit-name]');
          if (nm && nm.value.trim()) fd.append('properties[' + d.propName + ']', nm.value.trim());
          if (n > 1) fd.append('properties[' + (d.propPack || 'Pack') + ']', (k + 1) + ' de ' + n);
          if (k === n - 1 && drawer && typeof drawer.getSectionsToRender === 'function') {
            fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
            fd.append('sections_url', window.location.pathname);
          }
          return fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) throw new Error(res.description || res.message || 'No se pudo añadir.');
              last = res;
            });
        });
      });
      chain
        .then(function () {
          if (drawer && typeof drawer.renderContents === 'function' && last) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(last);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function (ex) { err.textContent = ex.message; })
        .finally(function () { btn.classList.remove('is-loading'); btn.disabled = false; });
    }
  }

  // Historias: abre a pantalla completa, avanza sola (fotos 5 s, vídeos al terminar)
  function initStories(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var modal = root.querySelector('[data-pl-hist-modal]');
    var stories = Array.prototype.slice.call(root.querySelectorAll('[data-pl-hist-story]'));
    var current = -1, timer = null, raf = null;

    function stop() {
      clearTimeout(timer);
      cancelAnimationFrame(raf);
      stories.forEach(function (s) { var v = s.querySelector('video'); if (v) v.pause(); });
    }
    function close() {
      stop();
      stories.forEach(function (s) { s.hidden = true; });
      modal.hidden = true;
      document.body.style.overflow = '';
      current = -1;
    }
    function show(i) {
      if (i < 0 || i >= stories.length) { close(); return; }
      stop();
      stories.forEach(function (s, k) { s.hidden = k !== i; });
      current = i;
      var s = stories[i], bar = s.querySelector('.pl-hist__bar span'), v = s.querySelector('video');
      bar.style.width = '0';
      if (v) {
        v.currentTime = 0;
        v.play().catch(function () {});
        v.onended = function () { show(current + 1); };
        (function tick() {
          if (v.duration) bar.style.width = (v.currentTime / v.duration * 100) + '%';
          raf = requestAnimationFrame(tick);
        })();
      } else {
        var start = Date.now();
        (function tick() {
          bar.style.width = Math.min(100, (Date.now() - start) / 50) + '%';
          raf = requestAnimationFrame(tick);
        })();
        timer = setTimeout(function () { show(current + 1); }, 5000);
      }
    }
    root.querySelectorAll('[data-pl-hist-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        show(parseInt(b.getAttribute('data-pl-hist-open'), 10));
      });
    });
    root.querySelector('[data-pl-hist-close]').addEventListener('click', close);
    root.querySelector('[data-pl-hist-prev]').addEventListener('click', function () { show(Math.max(0, current - 1)); });
    root.querySelector('[data-pl-hist-next]').addEventListener('click', function () { show(current + 1); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  }

  // Muro de reseñas: el formulario se abre con el botón (sigue abierto si viene de un envío o un error)
  function initReviews(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var box = root.querySelector('[data-pl-op-form]');
    var btn = root.querySelector('[data-pl-op-open]');
    if (!box || !btn) return;
    box.hidden = !box.querySelector('.pl-op__ok, .pl-op__err');
    btn.addEventListener('click', function () {
      box.hidden = !box.hidden;
      if (!box.hidden) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-pl-op]').forEach(initReviews);
    (root || document).querySelectorAll('[data-pl-hist]').forEach(initStories);
    (root || document).querySelectorAll('[data-pl-slider]').forEach(initSlider);
    (root || document).querySelectorAll('[data-pl-product]').forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
